import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { watchedHoursGridApi } from "../../constants/apiConstants";
import request from "../../utils/request";

export const watchedHoursGrid = createAsyncThunk(
  "watchedHoursGridReducer/watchedHoursGrid",
  async ({ payload, initialRequest = true }) => {
    try {
      const res = await request({
        url: watchedHoursGridApi.watchedHoursGrid,
        method: "POST",
        data: payload,
      });

      return { res, initialRequest, pageNumber: payload.pageNumber };
    } catch (error) {
      console.error("watched hours fetch is failed:", error);
      throw error;
    }
  }
);

const watchedHoursGridSlice = createSlice({
  name: "watchedHoursGrid",
  initialState: {
    getWatchedHoursGridReq: [],
    isgetwatchedHoursGridLoading: false,
    pageNumber: 1,
  },
  reducers: {
    watchedHoursGridRes: (state, action) => {
      state.getWatchedHoursGridReq = action.payload?.res;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(watchedHoursGrid.pending, (state) => {
        state.isgetwatchedHoursGridLoading = true;
      })
      .addCase(watchedHoursGrid.fulfilled, (state, action) => {
        state.isgetwatchedHoursGridLoading = false;
        if (action.payload?.initialRequest) {
          // Replace data on initial request
          state.getWatchedHoursGridReq =
            action.payload?.res?.response ?? [];
          state.pageNumber = 1;
        } else {
          if(action.payload?.pageNumber > state.pageNumber){
            // Concatenate data on subsequent requests
            state.getWatchedHoursGridReq = state.getWatchedHoursGridReq.concat(
              action.payload?.res?.response ?? []
            );
            state.pageNumber += 1;
          }
        }
      })
      .addCase(watchedHoursGrid.rejected, (state, action) => {
        state.isgetwatchedHoursGridLoading = false;
      });
  },
});
export const { watchedHoursGridRes } = watchedHoursGridSlice.actions;
export default watchedHoursGridSlice.reducer;
